/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Cache_LabelInputs */

const bn_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যাচে`)
};

const de_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const el_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΚΡΥΠΤΗ`)
};

const en_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const es_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const fr_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const hi_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैश`)
};

const hu_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const id_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const it_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const ja_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャッシュ`)
};

const ko_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`은닉처`)
};

const nl_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const pl_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KRYJÓWKA`)
};

const pt_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const ru_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`КЭШ`)
};

const sv_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CACHE`)
};

const tr_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÖNbellek`)
};

const uk_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`КЕШ`)
};

const vi_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BỘ NHỚ`)
};

const zh_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缓存`)
};

const zh_hant_cipher_system_cache_label = /** @type {(inputs: Cipher_System_Cache_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快取`)
};

/**
* | output |
* | --- |
* | "CACHE" |
*
* @param {Cipher_System_Cache_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_cache_label = /** @type {((inputs?: Cipher_System_Cache_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Cache_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_cache_label(inputs)
	if (locale === "de") return de_cipher_system_cache_label(inputs)
	if (locale === "el") return el_cipher_system_cache_label(inputs)
	if (locale === "en") return en_cipher_system_cache_label(inputs)
	if (locale === "es") return es_cipher_system_cache_label(inputs)
	if (locale === "fr") return fr_cipher_system_cache_label(inputs)
	if (locale === "hi") return hi_cipher_system_cache_label(inputs)
	if (locale === "hu") return hu_cipher_system_cache_label(inputs)
	if (locale === "id") return id_cipher_system_cache_label(inputs)
	if (locale === "it") return it_cipher_system_cache_label(inputs)
	if (locale === "ja") return ja_cipher_system_cache_label(inputs)
	if (locale === "ko") return ko_cipher_system_cache_label(inputs)
	if (locale === "nl") return nl_cipher_system_cache_label(inputs)
	if (locale === "pl") return pl_cipher_system_cache_label(inputs)
	if (locale === "pt") return pt_cipher_system_cache_label(inputs)
	if (locale === "ru") return ru_cipher_system_cache_label(inputs)
	if (locale === "sv") return sv_cipher_system_cache_label(inputs)
	if (locale === "tr") return tr_cipher_system_cache_label(inputs)
	if (locale === "uk") return uk_cipher_system_cache_label(inputs)
	if (locale === "vi") return vi_cipher_system_cache_label(inputs)
	if (locale === "zh") return zh_cipher_system_cache_label(inputs)
	return zh_hant_cipher_system_cache_label(inputs)
});